<div
  #scrollContainer
  class="no-scrollbar flex max-h-full w-full flex-col gap-2 overflow-y-auto pl-4"
>
  @for (task of taskList(); track task; let first = $first; let last = $last) {
    @if (
      taskListExpanded() || (!taskListExpanded() && task.state === 'inProgress')
    ) {
      <div
        [id]="task.identifier"
        class="bo-normal flex w-full flex-none snap-start flex-col justify-center gap-3 rounded-lg px-3 py-2 !text-bo-white backdrop-blur-lg"
        [ngClass]="
          task.state === 'inProgress'
            ? 'e2e-inProgress min-h-[72px] animate-pop border-4 border-bo-primary bg-gradient-to-br from-bo-primary/70 via-bo-black/70 via-30% to-bo-black/70'
            : task.state === 'completed'
              ? 'e2e-completed h-[72px] bg-gradient-to-br from-bo-green/50 via-bo-black/50 via-30% to-bo-black/50'
              : task.state === 'skipped'
                ? 'e2e-skipped h-[72px] bg-gradient-to-br from-bo-yellow/30 via-bo-black/50 via-30% to-bo-black/50'
                : task.state === 'failed'
                  ? 'e2e-failed h-[72px] bg-gradient-to-br from-bo-red/30 via-bo-black/50 via-30% to-bo-black/50'
                  : 'h-[72px] bg-bo-black/50'
        "
        data-e2e="task"
      >
        <div class="flex h-full">
          <div
            class="flex w-[32px] flex-none flex-col items-start justify-center"
          >
            @if (task.state === 'inProgress') {
              <div
                class="flex h-full flex-col justify-center pl-1"
                (click)="taskService.skipTask()"
              >
                <div class="flex cursor-pointer text-bo-primary">
                  <svg-icon
                    src="fa-icons/angles-down.svg"
                    class="fill-bo-white"
                    [svgStyle]="{ 'height.px': 16 }"
                  />
                </div>
              </div>
            }

            @if (task.state === 'upComing') {
              <svg-icon
                class="fill-bo-white"
                src="icons/up-coming.svg"
                [svgStyle]="{ 'width.px': 20 }"
              />
            }

            @if (task.state === 'completed') {
              <svg-icon
                class="fill-bo-green"
                src="icons/completed.svg"
                [svgStyle]="{ 'width.px': 20 }"
              />
            }
            @if (task.state === 'skipped') {
              <svg-icon
                class="fill-bo-yellow"
                src="icons/skipped.svg"
                [svgStyle]="{ 'width.px': 20 }"
              />
            }
            @if (task.state === 'failed') {
              <svg-icon
                class="fill-bo-red"
                src="icons/failed.svg"
                [svgStyle]="{ 'width.px': 20 }"
              />
            }
          </div>

          <div class="flex flex-1 flex-col justify-center py-2">
            <div
              class="leading-tight"
              [ngClass]="{
                'bo-title !text-bo-white': task.state === 'inProgress',
              }"
            >
              {{ task.description }}
            </div>
            @if (task.state === 'inProgress') {
              <div class="leading-tight">
                <div>
                  @if (task.guidance) {
                    <div>{{ task.guidance }}</div>
                  }
                  @if (task.media) {
                    <div class="mt-2">
                      @if (task.media.includes('.mp4')) {
                        <div>
                          <video
                            [src]="
                              sceneStore.path() +
                              '/assets/tasks/' +
                              (appService.dominantHand() === 'right'
                                ? task.media
                                : (task.mediaLeft ?? task.media))
                            "
                            class="rounded-md"
                            autoplay
                            loop
                            (loadedmetadata)="
                              scrollTo(taskService.currentTaskId())
                            "
                          ></video>
                        </div>
                      }
                      @if (task.media.includes('.jpg')) {
                        <img [src]="task.media" class="rounded-md" />
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      @if (task.button && task.state === 'inProgress') {
        <button
          class="bo-button"
          (click)="taskService.completeTask(task.identifier)"
        >
          Press to confirm task
        </button>
      }
    }
  }

  @if (taskService.taskListCompleted()) {
    <div
      class="bo-normal flex h-[72px] w-full flex-none animate-pulsation items-center justify-center gap-1 rounded-lg bg-bo-green/70 px-3 !text-bo-white backdrop-blur-lg"
    >
      <svg-icon class="fill-bo-white" src="icons/completed.svg" />
      Tasks completed
    </div>
  }
</div>
@if (taskService.taskList.length) {
  <div
    class="mt-2 flex w-full cursor-pointer items-center justify-center"
    (click)="
      taskListExpanded.set(!taskListExpanded()); taskService.currentTask()
    "
  >
    @if (!taskListExpanded()) {
      <img class="h-8 w-8" src="icons/expand-list.svg" />
    }
    @if (taskListExpanded()) {
      <img class="h-8 w-8" src="icons/collapse-list.svg" />
    }
  </div>
}
